import { doFetchAllChangesetsTicketActions } from 'actions/tickets'
import { doTogglePrintMode } from 'actions/app'

export const doPrintWholeTicket = ticketId => dispatch => {
  dispatch(doFetchAllChangesetsTicketActions(ticketId)).then(() => {
    dispatch(doTogglePrintMode(true))
    setTimeout(() => {
      window.print()
      dispatch(doTogglePrintMode(false))
    }, 500)
  })
}
